import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const C=i`
<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    static
    fill="none">
    <g clip-path="url(#clip0_10270_425)">
        <path
            d="M20.449 9.58834C14.061 6.34034 6.801 12.3033 10.121 17.7743C11.662 20.3443 15.22 21.9673 19.43 20.7493C20.272 21.0763 21.022 21.6063 21.838 22.0003C21.627 21.2903 21.402 20.5883 21.162 19.8893C25.512 16.7903 24.56 11.6763 20.449 9.58834ZM15.35 13.2763C15.141 13.9313 14.194 14.1273 13.735 13.6293C13.229 13.1683 13.426 12.2053 14.09 11.9993C14.824 11.6893 15.672 12.5403 15.35 13.2763ZM20.13 13.3703H20.144C19.887 13.9573 19.003 14.0953 18.569 13.6403C18.36 13.4483 18.299 13.1593 18.225 12.9073C18.329 12.4473 18.645 11.9703 19.155 11.9483C19.86 11.8503 20.491 12.7243 20.13 13.3703Z"
            fill="#51C332" />
        <path
            d="M17.4138 8.24802C16.9778 6.10402 15.4778 4.29302 13.5898 3.24802H13.6168C6.9168 -0.537979 -1.4252 4.74202 0.186805 10.97C0.619805 12.818 1.8978 14.367 3.4488 15.401C3.1488 16.254 2.8638 17.107 2.5938 17.966C3.5688 17.454 4.5438 16.919 5.5198 16.399C6.6898 16.776 7.9348 16.96 9.1798 16.919C7.6418 12.507 11.5868 7.83302 17.4138 8.24802ZM11.3368 5.68702C12.1218 5.37102 13.0498 6.03202 12.9878 6.87702L12.9898 6.88902C12.9978 7.85402 11.7148 8.45602 10.9948 7.80202C10.2478 7.26402 10.4598 5.95702 11.3368 5.68702ZM6.9318 7.13402C6.7598 7.97202 5.6408 8.37702 4.9858 7.81402C4.2268 7.27702 4.4398 5.94602 5.3308 5.67502C6.2038 5.33702 7.1958 6.22702 6.9318 7.13402Z"
            fill="#51C332" />
    </g>
    <defs>
        <clipPath id="clip0_10270_425">
            <rect
                width="24"
                height="24"
                fill="white" />
        </clipPath>
    </defs>
</svg>
`,e=t("wechat",C),p=t("we_chat",C);export{e as WeChat,p as WeChatAlt};
